import {
  didCaptionDeliveryInputsChange,
  getCaptionStatusChanges,
  reportCaptionStatusChange,
} from '../helpers/captionStatusChanges';
import type { AppStartListening } from '../helpers/types';

// When caption status is On or Off: the owner reports active delivery
// (request plus a connected hearing), not mere demand.
// Off is only for an On this client already sent. Takeover reports On again.
// SignMail/AST blocking is not a trigger.
export const registerCaptionStatusListeners = (
  startListening: AppStartListening
) => {
  startListening({
    predicate: (_action, currentState, previousState) =>
      didCaptionDeliveryInputsChange(currentState, previousState),
    effect: async (_action, api) => {
      // Read state now, not the predicate snapshot. An earlier listener may
      // have cleared peer or deaf demand in this same turn.
      // getOriginalState is only valid synchronously, before the first await.
      const changes = getCaptionStatusChanges(
        api.getState(),
        api.getOriginalState()
      );

      for (const change of changes) {
        await reportCaptionStatusChange(api, change);
      }
    },
  });
};
